import { render } from "./EditTaxe.vue?vue&type=template&id=4cec63ca"
import script from "./EditTaxe.vue?vue&type=script&lang=js"
export * from "./EditTaxe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__